import { render, staticRenderFns } from "./FormDefault.vue?vue&type=template&id=31980377&scoped=true&"
import script from "./FormDefault.vue?vue&type=script&lang=js&"
export * from "./FormDefault.vue?vue&type=script&lang=js&"
import style0 from "./FormDefault.vue?vue&type=style&index=0&id=31980377&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31980377",
  null
  
)

component.options.__file = "FormDefault.vue"
export default component.exports